import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RootMaterialModule } from 'src/app/shared/modules/root-material.module';
import { BoltSidenavModule } from '../bolt-sidenav/bolt-sidenav.module';
import { LayoutContentComponent } from './layout-content/layout-content.component';
import { LayoutComponent } from './layout.component';

const routes: Routes = [
  {
    path: 'layout',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        loadChildren: () =>
          import('../../screens/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'create-diet-plan',
        loadChildren: () =>
          import('../../screens/create-diet-plan/create-diet-plan.module').then(
            (m) => m.CreateDietPlanModule
          ),
      },
      {
        path: 'edit-diet-plan/:id',
        loadChildren: () =>
          import('../../screens/create-diet-plan/create-diet-plan.module').then(
            (m) => m.CreateDietPlanModule
          ),
      },
      {
        path: 'view-diet-plan/:id',
        loadChildren: () =>
          import('../../screens/view-diet-plan/view-diet-plan.module').then(
            (m) => m.ViewDietPlanModule
          ),
      },
      {
        path: 'view-all-diet-plans',
        loadChildren: () =>
          import('../../screens/view-diet-plan/view-diet-plan.module').then(
            (m) => m.ViewDietPlanModule
          ),
      },
      {
        path: 'diet-questionnaire',
        loadChildren: () =>
          import(
            '../../screens/diet-questionnaire/diet-questionnaire.module'
          ).then((m) => m.DietQuestionnaireModule),
      },
      {
        path: 'admin',
        loadChildren: () =>
          import('../../screens/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: 'appointment',
        loadChildren: () =>
          import('../../screens/appointment/appointment.module').then(
            (m) => m.AppointmentModule
          ),
      },
      {
        path: 'create-client-profile',
        loadChildren: () =>
          import('../../screens/client-profile/client-profile.module').then(
            (m) => m.ClientProfileModule
          ),
      },
      {
        path: 'employee-entry',
        loadChildren: () =>
          import('../../screens/employee-entry/employee-entry.module').then(
            (m) => m.EmployeeEntryModule
          ),
      },
      // {
      //   path: 'employee-entry',
      //   loadChildren: () =>
      //     import('../../screens/employee-entry/employee-entry.module').then(
      //       (m) => m.EmployeeEntryModule
      //     ),
      // },
      // {
      //   path: 'student-details',
      //   loadChildren: () =>
      //     import('../../screens/student-details/student-details.module').then(
      //       (m) => m.StudentDetailsModule
      //     ),
      // },
    ],
  },
];
@NgModule({
  declarations: [LayoutComponent, LayoutContentComponent],
  imports: [
    CommonModule,
    RootMaterialModule,
    BoltSidenavModule,
    RouterModule.forChild(routes),
  ],
})
export class LayoutModule {}
